import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_2 = { class: "text-xl font-bold text-textPrimary" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#52526f]" }, " Documento aprovado vale para todas as empresas em que o médico atua. ", -1)
const _hoisted_4 = {
  class: "flex flex-col gap-4 text-left",
  "data-testid": "approve-document-modal"
}
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = { class: "text-sm font-semibold text-textPrimary" }
const _hoisted_7 = { class: "text-xs text-[#52526f]" }
const _hoisted_8 = { class: "-mt-2 text-[11px] text-[#7f7f8e]" }
const _hoisted_9 = {
  key: 1,
  class: "text-[11px] text-[#7f7f8e]"
}
const _hoisted_10 = { class: "flex gap-4 w-full" }
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = { class: "flex-1" }

import { ref, watch } from 'vue'

import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import InputDate from '@/components/designSystem/Inputs/InputDate.vue'
import Input from '@/components/designSystem/Inputs/Input.vue'
import type { ApproveTarget } from '@/pinia-store/useDocumentReviewStore'

import { buildApprovePayload, todayInSaoPaulo, validateApproveForm } from '../model'
import type { ApproveFormItem } from '../model'

export interface ApproveModalItem {
  versionId: number
  userId: number
  documentName: string
  professionalName: string
  crmLabel: string | null
  hasExpiry: boolean
  acceptsAuthenticityCode: boolean
  /** Texto "Como conferir" do catálogo, repetido junto da validade. */
  description: string | null
}

type FieldValues = Pick<ApproveFormItem, 'expiresAt' | 'authenticityCode'>

export default /*#__PURE__*/_defineComponent({
  __name: 'ApproveDocumentModal',
  props: {
    modelValue: { type: Boolean },
    items: {},
    isSaving: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;




const form = ref<Record<number, FieldValues>>({})
const errors = ref<Record<number, string>>({})

// Abrir (ou trocar os itens) começa um formulário limpo: nada da decisão anterior vaza.
watch(
  () => [props.modelValue, props.items.map((item) => item.versionId).join(',')],
  () => {
    form.value = Object.fromEntries(
      props.items.map((item) => [item.versionId, { expiresAt: '', authenticityCode: '' }])
    )
    errors.value = {}
  },
  { immediate: true }
)

function setField(versionId: number, field: keyof FieldValues, value: string) {
  form.value = { ...form.value, [versionId]: { ...form.value[versionId], [field]: value } }
  if (field === 'expiresAt' && errors.value[versionId]) {
    const next = { ...errors.value }
    delete next[versionId]
    errors.value = next
  }
}

const toFormItem = (item: ApproveModalItem): ApproveFormItem => ({
  versionId: item.versionId,
  hasExpiry: item.hasExpiry,
  acceptsAuthenticityCode: item.acceptsAuthenticityCode,
  expiresAt: form.value[item.versionId]?.expiresAt ?? '',
  authenticityCode: form.value[item.versionId]?.authenticityCode ?? ''
})

function confirm() {
  const formItems = props.items.map(toFormItem)
  errors.value = validateApproveForm(formItems, todayInSaoPaulo())
  if (Object.keys(errors.value).length) return
  emit(
    'confirm',
    props.items.map((item, index) => ({
      versionId: item.versionId,
      userId: item.userId,
      payload: buildApprovePayload(formItems[index])
    }))
  )
}

function close() {
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[560px]",
    onClose: close
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.items.length > 1 ? `Aprovar ${_ctx.items.length} documentos` : 'Aprovar documento'), 1),
        _hoisted_3
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(OutlineButton, {
            text: "Cancelar",
            width: "100%",
            height: "48px",
            "data-testid": "approve-document-cancel",
            onClick: close
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(FilledButton, {
            text: _ctx.items.length > 1 ? `Aprovar ${_ctx.items.length}` : 'Aprovar documento',
            width: "100%",
            height: "48px",
            loading: _ctx.isSaving,
            disabled: _ctx.isSaving,
            "data-testid": "approve-document-confirm",
            onClick: confirm
          }, null, 8, ["text", "loading", "disabled"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.versionId,
            class: "flex flex-col gap-3 rounded-lg border border-[#e8e8ed] p-3",
            "data-testid": `approve-document-item-${item.versionId}`
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(item.documentName), 1),
              _createElementVNode("p", _hoisted_7, [
                _createTextVNode(_toDisplayString(item.professionalName), 1),
                (item.crmLabel)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" · " + _toDisplayString(item.crmLabel), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            (item.hasExpiry)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(InputDate, {
                    label: "Data de validade",
                    required: "",
                    mask: "##/##/####",
                    width: "100%",
                    value: form.value[item.versionId]?.expiresAt ?? '',
                    "is-error": !!errors.value[item.versionId],
                    "error-message": errors.value[item.versionId] ?? '',
                    "data-testid": `approve-document-expiry-${item.versionId}-input`,
                    "onUpdate:modelValue": (value) => setField(item.versionId, 'expiresAt', value)
                  }, null, 8, ["value", "is-error", "error-message", "data-testid", "onUpdate:modelValue"]),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(item.description ? `${item.description} ` : '') + "O médico é avisado em D-14, D-3 e D0; o documento vira Pendente em D+1. ", 1)
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, "Este tipo não tem validade.")),
            (item.acceptsAuthenticityCode)
              ? (_openBlock(), _createBlock(Input, {
                  key: 2,
                  label: "Código de autenticidade (opcional)",
                  width: "100%",
                  max: "100",
                  value: form.value[item.versionId]?.authenticityCode ?? '',
                  "data-testid": `approve-document-code-${item.versionId}-input`,
                  "onUpdate:modelValue": 
            (value) => setField(item.versionId, 'authenticityCode', value)
          
                }, null, 8, ["value", "data-testid", "onUpdate:modelValue"]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})